// src/utils/forms/dateTimeHelpers.js

/**
 * ✅ Format time to HH:mm (without seconds)
 */
export const formatTime = (timeString) => {
    if (!timeString || timeString.trim() === '') return null;

    // Already in HH:mm format
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/;
    if (timeRegex.test(timeString)) {
        return timeString;
    }

    // Has seconds, remove them
    const timeRegexWithSeconds = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
    if (timeRegexWithSeconds.test(timeString)) {
        return timeString.substring(0, 5);
    }

    return null;
};

/**
 * ✅ Format date to YYYY-MM-DD
 */
export const formatDate = (dateString) => {
    if (!dateString || dateString.trim() === '') return null;

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) return null;

    return dateString;
};

/**
 * ✅ Compare two times (HH:mm format)
 * Returns true if time2 is after time1
 */
export const isTimeAfter = (time1, time2) => {
    if (!time1 || !time2) return true;

    const [h1, m1] = time1.split(':').map(Number);
    const [h2, m2] = time2.split(':').map(Number);

    const minutes1 = h1 * 60 + m1;
    const minutes2 = h2 * 60 + m2;

    return minutes1 < minutes2;
};

/**
 * ✅ Check if end date is after start date
 */
export const isEndDateAfterStartDate = (startDate, endDate) => {
    if (!startDate || !endDate) return true;

    const start = new Date(startDate);
    const end = new Date(endDate);

    return end > start;
};
